// extracted by mini-css-extract-plugin
export var label = "_de-5";
export var slideContainer = "_de-0";
export var slider = "_de-1";
export var sliderLg = "_de-4";
export var sliderMd = "_de-3";
export var sliderSm = "_de-2";